/**
 *
 * @param {string} link
 * @param {boolean} newTabDisabled
 */
var handleOpenLink = function handleOpenLink(link, newTabDisabled) {
  if (!newTabDisabled) {
    window.open(link, '_blank');
  } else {
    window.location.href = link;
  }
};

export { handleOpenLink as h };
